import { useFetchParse } from "lib/hooks/useFetchParse";

const COMPANY_SEARCH_URL = "/research/japi/legal/company/search";
const DISCLOSURES_URL = "/research/japi/legal/company/disclosure";

export const useFetchSecurities = (date, assetClass, tickers) => {
  const condition = tickers.length > 0;
  const security = splitTickers(tickers);
  const body = JSON.stringify({ reportType: assetClass, security, asOfDate: date });
  return useFetchParse(COMPANY_SEARCH_URL, body, "POST", condition, parseSecurities);
};

const parseSecurities = (data) => {
  const securities = data.result && data.result.data && data.result.data.security;
  return securities || [];
};

export const useFetchDisclosures = (date, assetClass, securityIds) => {
  const condition = securityIds.length > 0;
  const body = JSON.stringify({ reportType: assetClass, securityID: securityIds, asOfDate: date });
  return useFetchParse(DISCLOSURES_URL, body, "POST", condition, parseDisclosures);
};

const parseDisclosures = (data) => {
  const html = data && data.result && data.result.data.value.disclosure;
  return html || "";
};

const splitTickers = (tickers) =>
  tickers
    .trim()
    .split(/[,\n]/)
    .map((s) => s.trim())
    .filter((s) => s);
